import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PromotionDetailsResponse } from '../models/promotion-details.model';
import { PromotionDetailsRepository } from '../repositories/promotion-details.repository';

export class GetPromotionDetailsUseCase
    implements UseCase<string, PromotionDetailsResponse>
{
    constructor(private readonly repository: PromotionDetailsRepository) {}

    execute(
        couponCode: string | null = null,
        couponUrl: string | null = null,
    ): Observable<PromotionDetailsResponse> {
        return this.repository.getPromotionDetails(couponCode, couponUrl);
    }
}
